import classNames from "classnames";
import { JSX, Ref, useState } from "react";
import Icon from "./Icon";
import Close from "./icons/close.svg?react";
import Search from "./icons/search.svg?react";
import styles from "./Input.module.css";

export type Props = JSX.IntrinsicElements["input"] & {
  isInvalid?: boolean;
  hint?: string;
  ref?: Ref<HTMLInputElement>;
};

const Input = ({ isInvalid, hint, ref, ...props }: Props) => {
  const { type = "text" } = props;
  return hint === undefined ? (
    <input
      ref={ref}
      {...props}
      type={type}
      className={classNames(styles.input, props.className, {
        [styles.invalid]: isInvalid,
      })}
    />
  ) : (
    <div className={styles.hinted}>
      <input
        ref={ref}
        {...props}
        type={type}
        className={classNames(styles.input, props.className, {
          [styles.invalid]: isInvalid,
          [styles.hinted]: hint !== undefined,
        })}
      />
      <span className={styles.hint}>{hint}</span>
    </div>
  );
};

interface SearchInputProps {
  placeholder?: string;
  value?: string;
  onChange?: (s: string) => void;
  className?: string;
  isLoading?: boolean;
}

export const SearchInput = ({
  placeholder,
  value,
  onChange,
  className,
  isLoading,
}: SearchInputProps) => {
  const [isFocused, setFocused] = useState(false);
  return (
    <div className={classNames(styles.search)}>
      <input
        type="search"
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        className={classNames(styles.input, className)}
      />
      {(value === undefined || value === "") && (
        <Icon
          glyph={Search}
          className={classNames(styles.icon, {
            [styles.focused]: isFocused,
          })}
        />
      )}
      {value !== undefined && value !== "" && !isLoading && (
        <Icon
          glyph={Close}
          className={classNames(styles.icon, {
            [styles.focused]: isFocused,
          })}
          onClick={() => onChange?.("")}
        />
      )}
      {isLoading && <span className={classNames(styles.icon)}>...</span>}
    </div>
  );
};

export default Input;
